module.exports = __webpack_public_path__ + "media/audio8.c4059d5e.mp3";